module.exports = __webpack_public_path__ + "static/loading-spinner-b90a907f5a0a456fe3bde9d0f5e002b4.svg";